module.exports = __webpack_public_path__ + "public/images/filter-icon.c661ad8f41abc6f89c5de1b45e4deb94.svg";